import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import moment from "moment"

import * as orderApis from "../../utilities/apis/order"
import { getOrderStatus } from "../../utilities/enumerations/constants"
import * as functions from "../../utilities/enumerations/functions"

export default function Order({ customer }) {
  const { token } = useSelector(state => state.user)
  const [orders, setOrders] = useState([])

  const getOrders = async (params) => {
    try {
      params.limit = 8
      const response = await orderApis.getOrders(token, functions.paramsToQuery(params))
      if (!response.status) throw new Error(response.message)

      setOrders(response.orders)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (customer) getOrders({ customer_id: customer.id })
    else setOrders([])
  }, [customer])

  return (
    <div className="card rounded-4 shadow-none">
      <div className="card-body p-3">
        <div className="d-flex flex-column gap-3">
          <p className="text-body-emphasis fw-bold m-0">Orders</p>
          {!!orders.length && <div className="d-flex flex-column gap-3">
            {orders.map((order) => {
              return (
                <div key={order.id.toString()} className="card rounded-4 shadow-none">
                  <div className="card-body p-3">
                    <div className="d-flex gap-2 align-items-center">
                      <p className="text-body-emphasis fw-bold m-0">#P{order.id}</p>
                      <p className="m-0">{getOrderStatus[order.order_status]}</p>
                    </div>
                    <p className="text-body-tertiary">{moment(order.order_datetime).format("Do MMM YYYY")} at {moment(order.order_datetime).format("hh:mm a")}</p>
                    <div className="row g-3">
                      <div className="col-md-8">
                        {order.order_lineitems.map((item, index) => {
                          return (
                            <p key={index.toString()} className="text-body-tertiary m-0">- {item.title} x{item.quantity} = {(item.quantity * (item.price - (item.discount || 0))).toFixed(2)}</p>
                          )
                        })}
                        <p className="text-body-tertiary mt-3 m-0"><span className="fw-bold">Sub Total:</span> Rs. {order.total.toFixed(2)}</p>
                        <p className="text-body-tertiary m-0"><span className="fw-bold">Discount:</span> Rs. {order.discount.toFixed(2)}</p>
                        <p className="text-body-tertiary m-0"><span className="fw-bold">Total:</span> Rs. {(order.total - order.discount).toFixed(2)}</p>
                      </div>
                      <div className="col-md-4">
                        <p className="text-body-emphasis fw-bold m-0"><i className="bi bi-person me-1"></i> Customer</p>
                        <p className="text-body-tertiary m-0">{order.customer.mobile}</p>
                        <p className="text-body-tertiary">{order.customer?.name}</p>

                        {order.driver && <>
                          <p className="text-body-emphasis fw-bold m-0"><i className="bi bi-truck me-1"></i> Rider</p>
                          <p className="text-body-tertiary">{order.driver.name}</p>
                        </>}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>}
        </div>
      </div>
    </div>
  )
}
